import { render, staticRenderFns } from "./articalsection.component.vue?vue&type=template&id=3fca12f9&scoped=true"
import script from "./articalsection.component.vue?vue&type=script&lang=js"
export * from "./articalsection.component.vue?vue&type=script&lang=js"
import style0 from "./articalsection.component.vue?vue&type=style&index=0&id=3fca12f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca12f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VImg,VRow})
